export const BOARDS_ENDPOINT = "/simb/all-boards-filtered";

export const WORKSPACES_AND_BOARDS = "/simb/workspaces-and-boards";

export const GET_ITEM_SETTINGS = "/simb/settings/item-settings";

export const UPDATE_ITEM_SETTINGS = "/simb/settings/update-item-settings";

export const ADD_ITEM_ENDPOINT = "/simb/add-item-and-sync";

export const ITEM_LOCATIONS_ENDPOINT = "/simb/item-locations";

export const DELETE_ALL = "/simb/delete-all";

export const DELETE = "/simb/delete-item";

export const UNLINK = "/simb/unlink-item";

export const UNLINK_ITEMS = "/simb/unlink-items";

export const UNLINK_ITEMS_STATUS = "/simb/unlink-items/status";

export const ITEM_MERGE_PREVIEW = "/simb/item-merge/preview";

export const ITEM_MERGE = "/simb/item-merge";

export const ITEM_MERGE_STATUS = "/simb/item-merge/status";

export const GET_CHANGELOG = "/simb/changelog";

export const GET_ACCOUNT_SETTINGS = "/simb/settings/account-settings";

export const GET_BOARD_SETTINGS = "/simb/settings/board-settings";

export const UPDATE_BOARD_SETTINGS = "/simb/settings/update-board-settings";

export const GET_CONNECTED_BOARDS = "/simb/settings/connected-boards";

export const SYNC_DELETION_SETTINGS = "/simb/settings/sync-deletion";

export const UPDATE_ACCOUNT_SETTING = "/simb/settings/update-account-settings";

/** Custom visual indicator (11948233901). Save takes { indicator?, mode: "save" | "swap" | "remove" }. */
export const VISUAL_INDICATOR = "/simb/settings/visual-indicator";
export const VISUAL_INDICATOR_ESTIMATE = "/simb/settings/visual-indicator/estimate";
export const VISUAL_INDICATOR_STATUS = "/simb/settings/visual-indicator/status";
export const VISUAL_INDICATOR_STOP = "/simb/settings/visual-indicator/stop";

export const USAGE_DATA = "/simb/usage/usageCharts";
export const USAGE_REFRESH = "/simb/usage/refresh";

export const OFFER_STATUS = "/simb/offer/status";
export const OFFER_ACCEPT = "/simb/offer/accept";
export const OFFER_DISMISS = "/simb/offer/dismiss";

export const DETAILED_USAGE_DATA = "/simb/usage/detailed-table";

export const REINSTALL_WEBHOOKS = "/simb/webhooks/reinstall";

export const GET_AUTHORIZED_USERS = "/simb/settings/authorized-users";

export const GET_SHARED_ITEMS_BOARD_VIEW = "/simb/board-view-items";

export const RESYNC_ITEM = "/simb/hard-resync";

export const ADD_ITEM_LOCATIONS_COLUMN = "/simb/item-locations/set-on-board";

/** Board Settings "Revalidate" for the app's "Boards" column: queues a boards_column.seed. */
export const SEED_BOARDS_COLUMN = "/simb/boards-column/seed";

export const TRANSFER_WEBHOOK_OWNERSHIP = "/simb/settings/transfer-ownership";

export const ITEM_VIEW_DISCREPANCY = "/simb/item-view-discrepancy";

export const ITEM_VIEW_RESYNC = "/simb/item-view-resync";

/** Fills a column just added to other boards from every connected item (dryRun counts them). */
export const SHARE_COLUMN_BACKFILL = "/simb/share-column-backfill";

export const GET_LATEST_COLUMN_VALUES = "/simb/get-latest-column-values";

export const RESYNC_ALL_COLUMNS_ITEMS = "/simb/resynchronize-all-columns";

export const ADD_COLUMN_TO_BOARD = "/simb/add-column-to-board";

export const GET_BOARD_WEBHOOKS = "/simb/webhooks/board-webhooks";

export const REINSTALL_SELECTED_WEBHOOKS = "/simb/webhooks/reinstall-selected";

export const COLLATED_UPDATES = "/simb/updates/collated";
export const RECORD_CONSENT = "/simb/consent/record";

export const GET_CONSENT_STATUS = "/simb/consent/status";

export const SUBITEM_DISCREPANCY_SCAN = "/simb/subitem-discrepancy/scan";
export const SUBITEM_DISCREPANCY_SCAN_START = "/simb/subitem-discrepancy/scan/start";
export const SUBITEM_DISCREPANCY_SCAN_STATUS = "/simb/subitem-discrepancy/scan/status";
export const SUBITEM_DISCREPANCY_SCAN_PARENT = "/simb/subitem-discrepancy/scan-parent";
export const SUBITEM_DISCREPANCY_PARENTS = "/simb/subitem-discrepancy/parents";
export const SUBITEM_RESYNC_COLUMN = "/simb/subitem-discrepancy/resync-column";
export const SUBITEM_RESYNC_SUBITEM = "/simb/subitem-discrepancy/resync-subitem";
export const SUBITEM_RESYNC_NAME = "/simb/subitem-discrepancy/resync-name";
export const SUBITEM_RESYNC_PARENT_NAME = "/simb/subitem-discrepancy/resync-parent-name";
export const SUBITEM_CREATE_MISSING = "/simb/subitem-discrepancy/create-missing";
export const SUBITEM_CONNECT = "/simb/subitem-discrepancy/connect";
export const SUBITEM_UNLINK = "/simb/subitem-discrepancy/unlink";

export const SUBITEM_BULK_SCAN = "/simb/subitem-discrepancy/bulk/scan";
export const SUBITEM_BULK_STATUS = "/simb/subitem-discrepancy/bulk/status";
export const SUBITEM_BULK_ACTIVE = "/simb/subitem-discrepancy/bulk/active";
export const SUBITEM_BULK_CONFIRM = "/simb/subitem-discrepancy/bulk/confirm";
export const SUBITEM_BULK_DRIFT = "/simb/subitem-discrepancy/bulk/drift";
